import {Component} from '@angular/core';
import {TokenStorageService} from "./services/token-storage.service";
import AuthHelper from "./Helper/AuthHelper";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  public date: Date = new Date()
  public navbarstate: number = 1;

  constructor(public tokenStorage: TokenStorageService, public authHelper: AuthHelper) {
  }

  public logout(): void {
    this.tokenStorage.deletetToken("access_token")
    this.tokenStorage.deletetToken("refresh_token")
    this.tokenStorage.deletetToken("user")
  }
}
